import { createSlice } from "@reduxjs/toolkit"
import { STATUSES } from "../../../util/constants";
import { graphqlApi } from "../api";
import { safeString } from "../../../util/functions";

const initialState = { 
  status: STATUSES.IDLE,
  message: undefined,
};

const devUsersSlice = createSlice({
    name: "devUsers",
    initialState,
    reducers: {
        setStatus(state, action) {
            state.status = action.payload;
        },
        setMessage(state, action) {
            state.message = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addMatcher(graphqlApi.endpoints.createUser.matchFulfilled, (state, response) => {
            response = response.payload?.createUser ?? {};
            
            state.message = safeString(response.message);
        });

        builder.addMatcher(graphqlApi.endpoints.createUser.matchPending, (state, response) => {
            state.message = "";
        });

        builder.addMatcher(graphqlApi.endpoints.createUser.matchRejected, (state, action) => {
            state.message = safeString(action.error.message);
        });
    }
});

const { setStatus, setMessage } = devUsersSlice.actions;
const { reducer } = devUsersSlice;

export { 
    setStatus,
    setMessage,
    reducer as default
};